import { createUseStyles } from 'react-jss';

export const headerBackground = '#ffffff';

export const useLayoutStyles = createUseStyles({
  layout: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    overflow: 'hidden',
  },
  header: {
    position: 'sticky',
    top: 0,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '64px',
    padding: '0 16px 0 16px',
    background: headerBackground,
    borderBottom: '1px solid #dddddd',
    zIndex: 1,
  },
  headerActions: {
    height: '100%',
    overflow: 'hidden',
  },
  pageHeader: {
    border: '1px solid rgb(235, 237, 240)',
    backgroundColor: headerBackground,
    paddingTop: 0,
    paddingBottom: 0,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    padding: '14px',
  },
  contentBody: {
    flex: 1,
  },
  footer: {
    textAlign: 'center',
    padding: '14px 14px 0 14px',
  },
  configFooter: {
    background: headerBackground,
    textAlign: 'center',
  },
  partnerName: {
    fontSize: '16px',
    fontWeight: 'normal',
  },
  hidden: {
    display: 'none',
  },
  headerTrigger: {
    height: '64px',
    paddingRight: '24px',
    marginLeft: '-10px',
    fontSize: '20px',
    cursor: 'pointer',
    transition: 'all .3s,padding 0s',
    ':hover': {
      background: headerBackground,
    },
  },
  breadCrumbs: {
    fontSize: '16px',
    display: 'flex',
    alignItems: 'center',
  },
});
